const DEFAULT_VIDEO_POSTER = '/images/hero/hero-video-poster.jpg';

const createImageItem = (src, caption) => ({
  type: 'image',
  src,
  caption
});

const createVideoItem = ({ mp4, webm = '', poster = DEFAULT_VIDEO_POSTER, caption }) => ({
  type: 'video',
  mp4,
  webm,
  poster,
  caption
});

export const PORTRAIT_GALLERY_ITEMS = [
  createImageItem('/images/hero/hero1-portrait.jpeg', 'Kurban hizmetimiz'),
  createImageItem('/images/hero/hero2-portrait.jpeg', 'Profesyonel süreç'),
  createImageItem('/images/hero/hero3-portrait.jpeg', 'Kaliteli ürün'),
  createVideoItem({
    webm: '/videos/hero/hero-bg.webm',
    mp4: '/videos/hero/hero-bg.mp4',
    caption: 'Çiftliğimizden görüntüler'
  })
];

